import { DeliveryDiscountsRepository } from '../repositories/delivery-discounts.repository'

import {
    AddUserDiscountPayload,
    DiscountTypePayload,
    GetDiscountTypeResponse,
    GetDiscountTypesParams,
    GetDiscountTypesResponse,
} from '@/core/types/delivery-discounts.types'

const deliveryDiscountsRepository = new DeliveryDiscountsRepository()

export class DeliveryDiscountsService {
    async getDiscountTypes(params: GetDiscountTypesParams): Promise<GetDiscountTypesResponse> {
        const response = await deliveryDiscountsRepository.getDiscountTypes(params)
        return response.data
    }

    async getDiscountType(discount_type_id: number): Promise<GetDiscountTypeResponse> {
        const response = await deliveryDiscountsRepository.getDiscountType(discount_type_id)
        return response.data
    }

    async createDiscountType(payload: DiscountTypePayload): Promise<void> {
        const response = await deliveryDiscountsRepository.createDiscountType(payload)
        return response.data
    }

    async updateDiscountType(
        discount_type_id: number,
        payload: DiscountTypePayload
    ): Promise<void> {
        const response = await deliveryDiscountsRepository.updateDiscountType(
            discount_type_id,
            payload
        )
        return response.data
    }

    async addUserDiscount(payload: AddUserDiscountPayload): Promise<void> {
        const response = await deliveryDiscountsRepository.addUserDiscount(payload)
        return response.data
    }
}
